module.exports = __webpack_public_path__ + "static/media/pres33.fce99500.png";